import React, { useState, useEffect } from 'react';
import axios from 'axios';
import backendURL from '../../config';
import {
  Box, Typography, Tabs, Tab, Paper, TextField, Button, CircularProgress,
  Card, CardContent, IconButton, Grid, Alert
} from '@mui/material';
import BalanceDisplay from './BalanceDisplay';
import CustomerPaymentsTable from './CustomerPaymentsTable';
import WithdrawalHistoryTable from './WithdrawalHistoryTable';


const PaymentsPage = () => {
  const [tabValue, setTabValue] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);
  const handleRefresh = () => setRefreshKey(prev => prev + 1);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
        <Box sx={{ display: 'flex', flexGrow: 1, mt: { xs: 0, md: 3  } }} >
          <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            <Typography variant="h4" component="h1" sx={{ mb: 3 }}>
                Manage Payments
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
                {/* Left Column (Tabs) */}
                <Box sx={{
                    borderColor: 'divider',
                    mb: { xs: 2, md: 0 },
                    mr: { xs: 0, md: 2 },
                    minWidth: '180px'
                }}>
                  <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    orientation="vertical"
                    variant="scrollable"
                    sx={{ borderRight: { md: 1 }, borderBottom: { xs: 1, md: 0 }, borderColor: 'divider' }}
                  >
                    <Tab label="Overview" />
                    <Tab label="Customer Payments" />
                    <Tab label="Withdrawal History" />
                  </Tabs>
                </Box>
                <Box sx={{ width: { xs: '100%', md: '80%' } }}>
                  {tabValue === 0 && <OverviewTab refreshKey={refreshKey} onRefresh={handleRefresh} />}
                  {tabValue === 1 && <CustomerPaymentsTab refreshKey={refreshKey} />}
                  {tabValue === 2 && <WithdrawalTransactionsTab refreshKey={refreshKey} />}
                </Box>
            </Box>
          </Box>
        </Box>
  );
};

const OverviewTab = ({ refreshKey, onRefresh }) => {
  const [summary, setSummary] = useState({ last_week: 0, last_month: 0, last_year: 0 });
  const token = localStorage.getItem("access_token");

  useEffect(() => {
    const source = axios.CancelToken.source();
    axios.get(`${backendURL}/payments/summary`, { headers: { Authorization: `Bearer ${token}` }, cancelToken: source.token })
      .then(res => setSummary(res.data.summary))
      .catch(err => { if (!axios.isCancel(err)) console.error("Failed to fetch summary", err); });
    return () => source.cancel();
  }, [refreshKey, token]);

  return (
    <Paper elevation={3} sx={{ p: 3 }}>
      <BalanceDisplay onWithdrawalSuccess={onRefresh} refreshKey={refreshKey} />

      <Box sx={{ display: 'flex', gap: 2, mt: 3, flexWrap: 'wrap' }}>
        <Card sx={{flex: 1, minWidth: '150px'}}><CardContent><Typography variant="h6">Last Week</Typography><Typography variant="h4">${Number(summary.last_week).toFixed(2)}</Typography></CardContent></Card>
        <Card sx={{flex: 1, minWidth: '150px'}}><CardContent><Typography variant="h6">Last Month</Typography><Typography variant="h4">${Number(summary.last_month).toFixed(2)}</Typography></CardContent></Card>
        <Card sx={{flex: 1, minWidth: '150px'}}><CardContent><Typography variant="h6">Last Year</Typography><Typography variant="h4">${Number(summary.last_year).toFixed(2)}</Typography></CardContent></Card>
      </Box>
      
      <Typography variant="h6" sx={{ mt: 3 }}>Recent Payments</Typography>
      <CustomerPaymentsTable perPage={5} showPagination={false} refreshKey={refreshKey} />
      
      <Typography variant="h6" sx={{ mt: 3 }}>Recent Withdrawals</Typography>
      {/* 
        --- CORRECTION IS HERE ---
        The WithdrawalHistoryTable's internal logic will now correctly show the refresh icon.
        We just need to ensure the `refreshKey` prop is passed down so it knows when to re-fetch its own data.
      */}
      <WithdrawalHistoryTable 
        perPage={5} 
        showPagination={false} 
        refreshKey={refreshKey} 
      />
    </Paper>
  );
};

const CustomerPaymentsTab = ({ refreshKey }) => (
  <Paper elevation={3} sx={{ p: 3 }}>
    <Typography variant="h5" gutterBottom>Customer Payments</Typography>
    <CustomerPaymentsTable refreshKey={refreshKey} />
  </Paper>
);

// --- CORRECTION IS HERE ---
// Pass the `onRefresh` prop down to the main history table as well, so it can
// also trigger a full re-render if needed, although its internal logic handles most cases.
const WithdrawalTransactionsTab = ({ refreshKey, onRefresh }) => (
  <Paper elevation={3} sx={{ p: 3 }}>
    <Typography variant="h5" gutterBottom>Withdrawal History</Typography>
    <WithdrawalHistoryTable refreshKey={refreshKey} />
  </Paper>
);

export default PaymentsPage;